module.exports = __webpack_public_path__ + "static/media/Rich Brian - Drive Safe.1a3cfebf.mp3";